var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardImage1Min(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 349,
    height: 262,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M256.416 260.295c17.169-1.218 34.667-3.25 50.114-10.789 15.447-7.54 28.652-21.628 30.803-38.599 2.151-16.97-6.706-33.729-5.423-50.8 1.136-15.054 10.018-28.463 12.922-43.281 3.479-17.735-2.374-37.02-15.149-49.865-9.852-9.929-23.027-15.783-35.894-21.417L219.68 13.067c-10.721-4.698-21.562-9.43-33.076-11.568-13.74-2.58-27.869-1.323-41.791-.066-17.083 1.51-34.874 3.29-49.422 12.333-15.467 9.597-25.152 26.145-39.009 37.965C41.157 64.707 20.61 72.297 10.157 89.328c-11.614 18.902-6.953 43.407 1.046 64.074C19.2 174.07 30.35 194.334 30.896 216.48c.465 18.922-1.63 34.007 19.482 36.275 21.926 2.359 44.27 3.647 66.303 5.357 46.462 3.581 93.187 5.482 139.735 2.183z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M45.263 231.369c1.737 5.834 9.332 7.097 15.437 7.293l181.38 5.709c12.821.402 25.698.804 38.444-.669a131.184 131.184 0 0 0 39.165-10.9c1.99-.91 4.171-2.112 4.712-4.225.878-3.405-2.995-6.035-6.348-7.132-10.337-3.35-21.456-3.053-32.318-2.761-69.237 1.881-139.66 4.984-208.84 1.307-8.045-.427-36.535-5.07-31.632 11.378z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.398 72.856v.694H62.841v-.694a11.862 11.862 0 0 1 3.5-8.42 11.988 11.988 0 0 1 8.453-3.486h188.652a11.985 11.985 0 0 1 8.453 3.486 11.861 11.861 0 0 1 3.499 8.42z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.398 72.856v.694H62.841v-.694a11.862 11.862 0 0 1 3.5-8.42 11.988 11.988 0 0 1 8.453-3.486h188.652a11.985 11.985 0 0 1 8.453 3.486 11.861 11.861 0 0 1 3.499 8.42z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.398 73.565H62.841v153.182h212.557V73.565z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M268.278 94.665c-.571 2.153-1.091 4.497-.828 6.8.207 1.776.853 3.32 1.272 4.995.874 3.521.692 7.459.546 11.246a459.303 459.303 0 0 0 .576 47.039c.156 1.7.181 3.41.075 5.115a37.276 37.276 0 0 1-.883 4.733 79.18 79.18 0 0 0-1.611 10.864c-.268 3.41-.308 7.042.621 10.115 1.222 4.024 3.843 6.373 6.408 8.022.626-2.162.742-4.612.843-6.996a1101.29 1101.29 0 0 0-.757-106.953c-.167-3.017 2.262-12.287-.142-8.163-1.696 2.862-5.196 9.602-6.12 13.183z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.847 215.284a4.567 4.567 0 0 0-.909 1.941c-.58 2.31-.45 4.741.374 6.976.258.699.899 1.509 1.575 1.192.175-.101.344-.211.505-.332a1.988 1.988 0 0 1 1.546.051c5.125 1.574 10.68 2.163 15.866.784.682-.181 1.444-.503 1.646-1.156.227-.765-.409-1.509-1.045-1.977-3.03-2.289-7.07-2.741-10.605-4.079a21.807 21.807 0 0 1-4.974-2.651c-1.328-.92-2.519-2.404-3.979-.749z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.63 217.809a6.852 6.852 0 0 0 2.726 3.043 10.862 10.862 0 0 0 6.636 2.012 3.681 3.681 0 0 0 1.964-.609 1.741 1.741 0 0 0 .722-1.811 2.536 2.536 0 0 0-.505-.87c-1.676-2.012-3.843-3.812-4.544-6.342-.162-.579-.273-1.238-.758-1.595a2.196 2.196 0 0 0-1.01-.327c-1.474-.226-3.913-.543-4.782.956a7.513 7.513 0 0 0-.449 5.543z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.089 161.676s1.631 25.803.611 28.041c-1.021 2.238-5.51 22.131-5.51 22.131s5.51 3.249 7.343 2.012c1.833-1.237 9.387-30.274 9.387-30.274l3.686-17.639-15.517-4.271z",
    fill: "#606161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.038 161.093s1.631 25.803.611 28.036c-1.02 2.233-5.509 22.131-5.509 22.131s5.509 3.254 7.342 2.012c1.833-1.242 9.382-30.269 9.382-30.269l3.677-17.68-15.503-4.23z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.12 149.997s1.58 11.272 7.393 13.002c5.812 1.731 21.829 7.314 21.829 7.314s-16.931 10.462-17.542 11.176c-.611.714-3.469 2.334-3.469 2.334l4.039 8.837s26.764-13.867 29.526-16.598c2.762-2.732 2.752-9.904 1.515-10.97-1.237-1.067-19.28-16.01-19.28-16.01l-24.011.915z",
    fill: "#606161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.12 149.997s1.58 11.272 7.393 13.002c5.812 1.731 21.829 7.314 21.829 7.314s-16.931 10.462-17.542 11.176c-.611.714-3.469 2.334-3.469 2.334l4.039 8.837s26.764-13.867 29.526-16.598c2.762-2.732 2.752-9.904 1.515-10.97-1.237-1.067-19.28-16.01-19.28-16.01l-24.011.915z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.426 99.195-.275-.099a.732.732 0 0 0-.937.438l-3.793 10.444a.728.728 0 0 0 .439.933l.276.1a.733.733 0 0 0 .937-.438l3.793-10.444a.73.73 0 0 0-.44-.934z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.586 74.682a7.134 7.134 0 0 1-1.636 6.166c-.354.439-.825.77-1.358.956a2.489 2.489 0 0 1-2.525-.906 5.181 5.181 0 0 1-1.01-2.58c-.379-2.515 0-5.995 1.767-7.972 1.768-1.977 4.464 2.947 4.762 4.336z",
    fill: "#606161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.586 74.682a7.134 7.134 0 0 1-1.636 6.166c-.354.439-.825.77-1.358.956a2.489 2.489 0 0 1-2.525-.906 5.181 5.181 0 0 1-1.01-2.58c-.379-2.515 0-5.995 1.767-7.972 1.768-1.977 4.464 2.947 4.762 4.336z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.689 94.067c0 .824-.03 1.84-.762 2.228a1.965 1.965 0 0 1-.803.166 4.562 4.562 0 0 1-2.717-.503 3.561 3.561 0 0 1-1.48-3.018c.05-1.165.33-2.308.824-3.365.747-1.83 1.691-3.672 3.292-4.839.242-.201.536-.332.848-.377 1.576-.106 2.576 3.018 2.384 4.215-.283 1.936-1.525 3.47-1.586 5.493z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.287 93.08s5.736-1.14 8.261 1.223c2.525 2.364 7.953 7.082 9.867 11.196 1.914 4.115 2.677 10.819 2.677 10.819l5.049 32.764s-20.502 3.199-24.021.916c-3.52-2.284.459-24.229-1.071-27.433-1.53-3.204-7.039-20.571-4.59-24.837 2.449-4.265 3.828-4.647 3.828-4.647z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.975 128.359s-7.342 7.515-12.624 4.874c-5.282-2.64-6.322-11.377-6.322-11.377l-4.823-19.586 13.796 21.009 9.18.408.793 4.672z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.028 99.86 12.695 14.326 8.11-3.808s4.439 5.181 4.439 7.006c0 1.826-13.008 10.975-14.993 9.145-1.984-1.831-14.396-15.542-15.608-17.675-1.212-2.133-2.601-11.428 5.357-8.993z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.043 84.761s-1.298 4.779.727 7.138l1.071.533 1.434-3.833-3.232-3.838z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.819 83.55c.184.238.286.529.293.83a.952.952 0 0 1-.177.391c-.873 1.323-2.287 2.188-3.282 3.42-.697.856-1.313 1.967-2.404 2.143a3.098 3.098 0 0 1-1.974-.503c-2.737-1.564-3.444-4.657-3.03-5.905.414-1.247 1.01-2.424 1.479-3.661.541-1.484.914-3.154 2.147-4.135a5.817 5.817 0 0 1 2.858-1.006 2.643 2.643 0 0 1 1.191.026c1.167.377 2.525 1.936 2.647 3.163.191 1.665-.581 3.692.252 5.236z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.794 79.727c-1.085.553-2.429.346-3.534.86-1.717.804-2.212 2.947-3.257 4.526-.591.886-1.389 1.61-2.061 2.435-3.221 3.953-3.343 9.647-6.145 13.907a.902.902 0 0 1-.344.357.945.945 0 0 1-.459.055 12.871 12.871 0 0 1-7.07-2.615 1.071 1.071 0 0 1-.505-1.348c1.414-6.463 5.212-12.182 6.928-18.575.455-1.68.763-3.405 1.435-5.03a14.297 14.297 0 0 1 2.792-4.18 10.255 10.255 0 0 1 4.07-2.816c2.444-.82 5.166-.257 7.504.825 2.525 1.157 4.201 2.967 3.858 5.84-.227 1.906-1.459 4.868-3.212 5.758z",
    fill: "#606161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.794 79.727c-1.085.553-2.429.346-3.534.86-1.717.804-2.212 2.947-3.257 4.526-.591.886-1.389 1.61-2.061 2.435-3.221 3.953-3.343 9.647-6.145 13.907a.902.902 0 0 1-.344.357.945.945 0 0 1-.459.055 12.871 12.871 0 0 1-7.07-2.615 1.071 1.071 0 0 1-.505-1.348c1.414-6.463 5.212-12.182 6.928-18.575.455-1.68.763-3.405 1.435-5.03a14.297 14.297 0 0 1 2.792-4.18 10.255 10.255 0 0 1 4.07-2.816c2.444-.82 5.166-.257 7.504.825 2.525 1.157 4.201 2.967 3.858 5.84-.227 1.906-1.459 4.868-3.212 5.758z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.812 108.804a13.16 13.16 0 0 1 2.48-.388 23.078 23.078 0 0 0 4.282-1.272c.591-.201 1.293-.372 1.788 0a1.318 1.318 0 0 1 .439 1.247c-.088.457-.26.893-.505 1.288l-1.515 2.786c-.505.901-1.01 1.836-1.858 2.385-1.212.764-2.768.578-4.176.85a8.232 8.232 0 0 1-1.965.321c-1.828-.09-2.752-2.087-2.414-3.722.324-1.458 2.096-3.033 3.444-3.495z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.407 186.317a3.256 3.256 0 0 0-.965.046 2.314 2.314 0 0 0-.944.709 19.098 19.098 0 0 0-2.889 3.621 11.814 11.814 0 0 0-1.01 8.254c.019.15.08.291.177.408.288.271.753 0 1.01-.292l7.792-7.595 1.383-1.348a.577.577 0 0 0 .106-.885l-.954-1.645a7.796 7.796 0 0 0-.919-1.574c-.404-.403-.626-.136-1.121.035a4.677 4.677 0 0 1-1.666.266z",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.483 185.522a18.484 18.484 0 0 0-5.014.921c-.621.176-1.379.528-1.343 1.172.035.644.727.925.949 1.428.14.504.09 1.041-.141 1.509a18.581 18.581 0 0 0-1.091 7.268 11.224 11.224 0 0 0 2.686 6.75 2.526 2.526 0 0 0 1.773 1.006c.858 0 1.515-.774 1.878-1.549 1.081-2.304.611-4.99.616-7.545a18.93 18.93 0 0 1 1.48-7.383c.262-.604 1.404-1.892 1.277-2.54-.217-.976-2.282-1.011-3.07-1.037z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.268 85.752H71.41v136.941h197.858V85.753z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.96 69.848a2.288 2.288 0 0 0 2.293-2.283 2.288 2.288 0 0 0-2.293-2.284 2.288 2.288 0 0 0-2.292 2.284 2.288 2.288 0 0 0 2.292 2.283z",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.61 69.848a2.288 2.288 0 0 0 2.293-2.283 2.288 2.288 0 0 0-2.292-2.284 2.288 2.288 0 0 0-2.293 2.284 2.288 2.288 0 0 0 2.293 2.283z",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.26 69.848a2.288 2.288 0 0 0 2.293-2.283 2.288 2.288 0 0 0-2.292-2.284 2.288 2.288 0 0 0-2.293 2.284 2.288 2.288 0 0 0 2.293 2.283z",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M106.086 83.112H72.43v143.237h33.656V83.112zM261.345 83.112h-46.538v143.237h46.538V83.112zM210.701 83.112H109.965v143.237h100.736V83.112z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M210.343 103.678H114.55v60.961h95.793v-60.961zM260.375 96.838h-39.796v27.85h39.796v-27.85z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.69 85.954H74.88v12.594h10.81V85.954zM180.499 91.34h-6.489v7.208h6.489V91.34zM141.631 91.285h-24.223v7.268h24.223v-7.268zM208.171 101.445h-95.656v59.593h95.656v-59.593zM169.935 91.285h-24.223v7.268h24.223v-7.268zM102.41 101.345H74.88v1.363h27.53v-1.363zM102.41 104.85H74.88v1.363h27.53v-1.363zM102.41 108.356H74.88v1.363h27.53v-1.363z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M205.222 112.973h-90.566v45.102h90.566v-45.102z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.254 96.315h-39.165v25.194h39.165V96.315z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24,
    fill: "#F7941D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.355 108.889h-3.126l-.434 1.463h-2.808l3.348-8.872h3l3.348 8.872h-2.884l-.444-1.463zm-.571-1.922-1.01-3.188-.974 3.188h1.984zM233.597 101.48h4.09a4.842 4.842 0 0 1 1.949.327c.483.204.907.526 1.232.936.33.422.57.906.707 1.423.148.562.221 1.14.217 1.72a5.939 5.939 0 0 1-.323 2.208 3.645 3.645 0 0 1-.904 1.313 2.912 2.912 0 0 1-1.242.704 6.372 6.372 0 0 1-1.636.242h-4.09v-8.873zm2.752 2.012v4.854h.671c.421.028.842-.039 1.233-.196.261-.149.462-.384.57-.664a4.167 4.167 0 0 0 .207-1.539c0-.941-.156-1.585-.464-1.932a1.954 1.954 0 0 0-1.515-.503l-.702-.02zM242.762 107.415l2.616-.161c.027.347.147.681.348.966a1.449 1.449 0 0 0 1.212.543c.327.022.65-.076.909-.276a.846.846 0 0 0 .318-.639.804.804 0 0 0-.303-.619 3.544 3.544 0 0 0-1.409-.503 6.073 6.073 0 0 1-2.58-1.076 2.167 2.167 0 0 1-.778-1.715 2.32 2.32 0 0 1 .399-1.293c.293-.431.71-.764 1.197-.956a5.635 5.635 0 0 1 2.186-.347 4.525 4.525 0 0 1 2.606.629 2.747 2.747 0 0 1 1.066 2.012l-2.596.151a1.364 1.364 0 0 0-.434-.875 1.424 1.424 0 0 0-.914-.272 1.1 1.1 0 0 0-.722.206.606.606 0 0 0-.243.503.502.502 0 0 0 .202.377c.278.178.592.291.919.332.891.16 1.76.422 2.591.78.466.222.86.571 1.136 1.006.237.397.359.851.353 1.313a2.784 2.784 0 0 1-.474 1.574 2.96 2.96 0 0 1-1.323 1.092 5.338 5.338 0 0 1-2.146.372c-1.515 0-2.564-.29-3.146-.87a3.424 3.424 0 0 1-.99-2.254z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.859 140.451h-6.716l-.934 3.149h-6.06l7.201-19.073h6.453l7.196 19.073h-6.181l-.959-3.149zm-1.227-4.129-2.116-6.851-2.091 6.851h4.207zM149.974 124.527h8.791a10.55 10.55 0 0 1 4.201.699 6.837 6.837 0 0 1 2.647 2.012 8.315 8.315 0 0 1 1.514 3.058c.319 1.206.477 2.449.47 3.697a12.835 12.835 0 0 1-.697 4.743 7.891 7.891 0 0 1-1.939 2.821 6.33 6.33 0 0 1-2.666 1.509c-1.151.32-2.34.489-3.535.503h-8.786v-19.042zm5.918 4.315v10.407h1.449a6.048 6.048 0 0 0 2.641-.418 2.79 2.79 0 0 0 1.227-1.428 8.898 8.898 0 0 0 .445-3.31c0-2.012-.337-3.397-1.01-4.154-.667-.745-1.763-1.117-3.298-1.117l-1.454.02zM169.678 137.287l5.63-.352c.06.747.316 1.465.742 2.082a3.126 3.126 0 0 0 2.611 1.157 2.877 2.877 0 0 0 1.954-.588 1.787 1.787 0 0 0 .687-1.373 1.753 1.753 0 0 0-.651-1.328c-.44-.388-1.45-.76-3.03-1.107-2.589-.583-4.441-1.355-5.555-2.314a4.657 4.657 0 0 1-1.671-3.686 4.984 4.984 0 0 1 .853-2.777 5.639 5.639 0 0 1 2.575-2.052 11.988 11.988 0 0 1 4.707-.749c2.45 0 4.317.452 5.6 1.358 1.282.905 2.047 2.347 2.292 4.325l-5.554.327a2.59 2.59 0 0 0-.917-1.857 2.608 2.608 0 0 0-1.987-.602 2.375 2.375 0 0 0-1.591.432 1.313 1.313 0 0 0-.504 1.057 1.037 1.037 0 0 0 .429.819c.6.38 1.278.621 1.984.705a24.88 24.88 0 0 1 5.555 1.684 5.849 5.849 0 0 1 2.444 2.113 5.36 5.36 0 0 1 .763 2.827 6.032 6.032 0 0 1-1.01 3.385 6.366 6.366 0 0 1-2.843 2.344 11.49 11.49 0 0 1-4.616.804c-3.259 0-5.514-.625-6.766-1.876a7.364 7.364 0 0 1-2.131-4.758z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M96.204 141.623H50.186c-3.43 0-6.21 2.77-6.21 6.187v44.005c0 3.417 2.78 6.187 6.21 6.187h46.018c3.43 0 6.211-2.77 6.211-6.187V147.81c0-3.417-2.78-6.187-6.21-6.187z",
    fill: "#F7941D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.841 137.966H46.823c-3.43 0-6.211 2.77-6.211 6.187v44.005c0 3.417 2.78 6.187 6.211 6.187h46.018c3.43 0 6.211-2.77 6.211-6.187v-44.005c0-3.417-2.78-6.187-6.21-6.187z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M76.798 182.218v-9.868c0-.383 0-.383-.374-.383h-6.2c-.374 0-.394 0-.394-.387v-7.303c0-.377 0-.387.388-.387h6.201c.38 0 .38 0 .38-.383v-5.844a11.448 11.448 0 0 1 1.211-5.246 8.875 8.875 0 0 1 2.461-2.969 8.924 8.924 0 0 1 3.493-1.649c1.828-.472 3.681-.402 5.53-.342 1.115.036 2.231.121 3.342.197.717.055.586.05.586.613v6.343c0 .357 0 .377-.374.377-1.282 0-2.565-.025-3.848 0a9.217 9.217 0 0 0-1.858.211 2.512 2.512 0 0 0-2.02 2.228c-.07.446-.107.897-.111 1.348v4.769c0 .281.086.357.364.357h7.14c.444 0 .444 0 .384.457l-.924 7.158c-.056.452-.056.462-.505.462h-6.01c-.424 0-.424 0-.424.418V192.247c0 .197-.076.247-.262.247h-7.918c-.288 0-.253-.171-.253-.342v-9.934h-.005z",
    fill: "#F7941D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 287.139,
    y1: 82.714,
    x2: 298.122,
    y2: 82.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAD4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 169.117,
    y1: 47.556,
    x2: 169.117,
    y2: 155.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 285.432,
    y1: 227.23,
    x2: 295.959,
    y2: 145.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 277.544,
    y1: 180.292,
    x2: 339.18,
    y2: 134.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 293.648,
    y1: 76.623,
    x2: 300.066,
    y2: 74.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 282.927,
    y1: 90.43,
    x2: 290.3,
    y2: 90.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAD4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 278.554,
    y1: 128.701,
    x2: 314.789,
    y2: 82.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 289.406,
    y1: 91.536,
    x2: 281.151,
    y2: 70.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 281.291,
    y1: 217.004,
    x2: 293.734,
    y2: 217.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAD4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 265.718,
    y1: 76.472,
    x2: 309.515,
    y2: 96.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 304.323,
    y1: 111.475,
    x2: 316.816,
    y2: 111.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAD4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 280.276,
    y1: 192.635,
    x2: 291.244,
    y2: 192.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5C6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EAD4D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 74.087,
    y1: 58.255,
    x2: 73.786,
    y2: 80.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 81.737,
    y1: 58.255,
    x2: 81.431,
    y2: 80.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 89.387,
    y1: 58.255,
    x2: 89.082,
    y2: 80.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h349v262H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardImage1Min);
export default __webpack_public_path__ + "static/media/Card Image 1-min.ea35b9e90276dafa2920ee106c6600b0.svg";
export { ForwardRef as ReactComponent };